export default async function updateRegistrosEChamados() {
    try {
        const response = await fetch(`${process.env.REACT_APP_SERVER_IP}/atualizarRegistrosEChamados`);
        if (!response.ok) {
            throw new Error(`Erro: ${response.status}`);
        }
        return await response.json();
    } catch (error) {
        console.error("Erro ao atualizar registros:", error);
        return [];
    }
}